module.exports = "//public.zight.com/packs/media/images/branding-a66a039e030371fcc5b50b55d1ab426b.svg";